import React from 'react';

function parseCaption(caption: string): (JSX.Element | string)[] {
  const regex = /\*(.*?)\*/g;
  let index = 0;
  let match: RegExpExecArray | null = regex.exec(caption);

  if (match === null) {
    return [caption];
  }

  const result: (JSX.Element | string)[] = [];

  do {
    if (match.index > index) {
      result.push(caption.slice(index, match.index));
    }
    result.push(<strong key={match.index}>{match[1]}</strong>);
    index = match.index + match[0].length;
    match = regex.exec(caption);
  } while (match);

  if (index < caption.length) {
    result.push(caption.slice(index));
  }

  return result;
}

function SlideText({ caption }) {
  return (
    <div className="rcw-page-slider-caption">
      <span>{parseCaption(caption)}</span>
    </div>
  );
}

export default SlideText;
